import { useEffect } from 'react'

import { fetchPropertyAnytimeRate } from 'actions/PropertyActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

interface Options {
  disabled?: boolean
}

type Return = [
  anytimeRates: App.State['offer']['propertyAnytimeRates'][string] | undefined,
  fetching: boolean,
  error: any,
]

function usePropertyAnytimeRate(
  propertyId: string | undefined = '',
  options: Options = {},
): Return {
  const dispatch = useAppDispatch()

  const anytimeRates = useAppSelector(state => state.offer.propertyAnytimeRates[propertyId])

  const isFetchRequired = !!propertyId && !options.disabled && !anytimeRates
  useEffect(() => {
    if (isFetchRequired) {
      dispatch(fetchPropertyAnytimeRate(propertyId))
    }
  }, [dispatch, isFetchRequired, propertyId])

  if (options.disabled) return [undefined, false, undefined]
  return [anytimeRates, anytimeRates?.fetching ?? isFetchRequired, anytimeRates?.error]
}

export default usePropertyAnytimeRate
